import { render } from "./BaseTableHeader.vue?vue&type=template&id=ab9b45e2"
import script from "./BaseTableHeader.vue?vue&type=script&lang=js"
export * from "./BaseTableHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gordonwong/Shedd/aerocle-client/aerocle-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__